import $ from "jquery";

class OrganizationsEG {

    constructor() {
        this.init();
    }

    init(){
        $(".esg-loadmore").attr("tabIndex", "0");

        $(".esg-loadmore").keydown((e) => {
            if(e.keyCode === 13) {
                $(".esg-loadmore").click();
              }
        })
    }
}

export default OrganizationsEG;